var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttritionGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 163,
    viewBox: "0 0 355 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M347.122 159.02C352.039 158.427 355.567 153.954 354.729 149.072C347.792 108.67 327.197 71.76 296.247 44.6057C263.044 15.4754 220.26 -0.3788 176.093 0.0810076C131.925 0.540815 89.4809 17.2823 56.8921 47.0976C26.514 74.8903 6.69161 112.221 0.59738 152.759C-0.138921 157.657 3.48152 162.055 8.40994 162.546C13.3384 163.037 17.706 159.433 18.4695 154.539C24.1084 118.398 41.8803 85.1412 68.9989 60.3306C98.3288 33.4968 136.529 18.4295 176.28 18.0157C216.03 17.6018 254.536 31.8706 284.418 58.0879C312.047 82.3286 330.508 115.208 336.898 151.224C337.763 156.101 342.205 159.613 347.122 159.02Z",
    fill: "#E9EDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39804 162.664C3.46928 162.176 -0.154232 157.781 0.578763 152.882C5.15761 122.284 17.5843 93.3354 36.7145 68.8907C55.8447 44.446 80.9581 25.4257 109.559 13.6268C114.137 11.7379 119.275 14.1987 120.933 18.8659C122.59 23.533 120.139 28.6369 115.571 30.5511C90.1736 41.194 67.8714 58.1804 50.8391 79.9444C33.8068 101.708 22.6787 127.44 18.4521 154.65C17.6919 159.545 13.3268 163.151 8.39804 162.664Z",
    fill: "#FFBAA5",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39804 162.664C3.46928 162.176 -0.154257 157.781 0.578745 152.883C4.34448 127.718 13.4226 103.641 27.2082 82.2545C29.8916 78.0916 35.5152 77.1826 39.5387 80.0707C43.5623 82.9588 44.4597 88.5494 41.7995 92.7271C29.8243 111.534 21.8742 132.619 18.4521 154.65C17.6919 159.544 13.3268 163.151 8.39804 162.664Z",
    fill: "#2350F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttritionGraph);
export default __webpack_public_path__ + "static/media/attrition-graph.4dc36629c2d4eca5c6da92837749e63d.svg";
export { ForwardRef as ReactComponent };